module.exports = "<div class=\"kd-item\" ng-click=\"$ctrl.seleccionar()\">\r\n  <i class=\"fa fa-fw fa-lg\"\r\n      ng-class=\"{\r\n        'fa-check-square text-primary': $ctrl.item.seleccionado,\r\n        'fa-square-o text-light': !$ctrl.item.seleccionado\r\n        }\"></i>\r\n  <div>{{$ctrl.item.colaborador}}</div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/configuracion/registrosPatronales/migrar/agrupacion/item/template.html
// module id = 2506
// module chunks = 0